import { createFileRoute } from "@tanstack/react-router";
import { CmsPage, librariesQueryOptions, pageQueryOptions, pageRefsQueryOptions, ensureReviewCounts, reviewCountsQueryOptions } from "@/lib/cms/page-loader";
import { img } from "@/assets/jaguar";
import { businessRatingJsonLd, combinedRating, type Rating } from "@/lib/seo/page-jsonld";
import { findHeroImage, heroPreloadLinks } from "@/lib/cms/hero-preload";

export const Route = createFileRoute("/en/")({
  head: ({ loaderData }) => {
    const data = loaderData as { heroImage: string | null; rating?: Rating } | undefined;
    return {
    meta: [
      { title: "Scuba Diving in Playa del Carmen | Jaguar Divers" },
      {
        name: "description",
        content:
          "PADI scuba diving, cenote diving, Cozumel reefs and bull-shark dives from Playa del Carmen. Small groups, certified instructors, English & Español.",
      },
      { property: "og:title", content: "Jaguar Divers — Scuba & Cenote Diving in Playa del Carmen" },
      { property: "og:description", content: "Cenote, ocean and Cozumel scuba diving with PADI-certified instructors in Playa del Carmen." },
      { property: "og:image", content: img.home },
      { property: "og:url", content: "https://jaguardivers.com/en" },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [
      ...heroPreloadLinks(data?.heroImage),
      { rel: "canonical", href: "https://jaguardivers.com/en" },

      { rel: "alternate", hrefLang: "en", href: "https://jaguardivers.com/en" },
      { rel: "alternate", hrefLang: "x-default", href: "https://jaguardivers.com/en" },
      { rel: "alternate", hrefLang: "es", href: "https://jaguardivers.com/es" },
    ],
    scripts: businessRatingJsonLd(data?.rating ?? null),
    };
  },
  loader: async ({ context }) => {
    const page = await context.queryClient.ensureQueryData(pageQueryOptions("", "en"));
    await Promise.all([
      context.queryClient.ensureQueryData(librariesQueryOptions("en")),
      context.queryClient.ensureQueryData(pageRefsQueryOptions),
      ensureReviewCounts(context.queryClient),
    ]);
    return {
      heroImage: findHeroImage(page?.sections),
      rating: combinedRating(context.queryClient.getQueryData(reviewCountsQueryOptions.queryKey)),
    };
  },
  component: () => <CmsPage slug="" language="en" />,
});
